import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { useSpotSwapRouter, useLimitOrderRouter } from '~/hooks'

interface TabConfig {
  path: string
  translationKey: string
  trackId: string
  isActive: boolean
  showNew?: boolean
}

export const useTabsConfig = (): TabConfig[] => {
  const isSpotSwap = useSpotSwapRouter()
  const isLimitOrder = useLimitOrderRouter()
  const router = useRouter()
  const isStaking = router.pathname === '/staking'

  return useMemo(
    () => [
      {
        path: '/instant',
        translationKey: 'exchange_tab_instant',
        trackId: 'webtl_menu_instant',
        isActive: isSpotSwap,
      },
      {
        path: '/limit-order',
        translationKey: 'exchange_tab_limit',
        trackId: 'webtl_menu_lo',
        isActive: isLimitOrder,
      },
      {
        path: '/staking',
        translationKey: 'staking_product',
        trackId: 'webtl_menu_stk',
        isActive: isStaking,
        showNew: true,
      },
    ],
    [isSpotSwap, isLimitOrder, isStaking],
  )
}
